
import { getNonEmpty } from '../../../../utils/helpers';
import EditIcon from "@material-ui/icons/Edit";
import { buttonsStyle } from "../../../components/tables/table";
import {
    Button,
    Tooltip
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { NewTable } from "../customers/EditCustomerPage";
import { useState } from 'react';
import { alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';

export default function TableFaq({ data, setData, setDataSelected, setDataOpen, tableKey, setTableKey }) {
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [faqOrder, setFaqOrder] = useState(null);


    function buttonFormatter(elem) {
        const currentIndex = data.findIndex((item) => item.order === elem.order);
        const canMoveUp = currentIndex > 0;
        const canMoveDown = currentIndex < data.length - 1;

        const swapItems = (from, to) => {
            const updatedData = [...data];
            const temp = updatedData[from];
            updatedData[from] = updatedData[to];
            updatedData[to] = temp;

            const reordered = updatedData.map((item, index) => ({
                ...item,
                order: index,
            }));

            setData(reordered);
            setTableKey(k => k + 1);
        };

        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setDataSelected(elem)
                            setDataOpen(true)
                        }
                        }
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setFaqOrder(elem.order)
                                    setOpenConfirmDialog(true)
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
                {canMoveUp && (
                    <Tooltip title="Move Up">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => swapItems(currentIndex, currentIndex - 1)}
                        >
                            <ArrowUpward />
                        </Button>
                    </Tooltip>
                )}
                {canMoveDown && (
                    <Tooltip title="Move Down">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => swapItems(currentIndex, currentIndex + 1)}
                        >
                            <ArrowDownward />
                        </Button>
                    </Tooltip>
                )}
            </>
        );
    }

    const columns = [
        { dataField: "title", text: "Title", formatter: (cell, row) => getNonEmpty(row.title) },
        { dataField: "responseFaq", text: "Response", formatter: (cell, row) => getNonEmpty(row.responseFaq) },
        { dataField: "order", text: "", formatter: (_, row) => buttonFormatter(row), headerStyle: { width: '200px' } },
    ];


    return (
        <>
            <div className="col-12">
                <NewTable key={tableKey} data={data} columns={columns} />
            </div>

            <ConfirmDialog
                title={"Are you sure you want to delete this category?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    const updatedData = data
                        .filter(item => item.order !== faqOrder)
                        .map((item, index) => ({
                            ...item,
                            order: index + 1,
                        }));
                    setData([...updatedData]);
                    setTableKey(k => k + 1);
                    alertSuccess({
                        title: "Deleted!",
                        customMessage: "Faq deleted successfully.",
                    });
                }}
            />
        </>
    );


}